import DOMPurify from "dompurify";

const PROP_IA_CHAT_FRAGMENT = {
  ALLOWED_TAGS: ["strong", "b"],
  ALLOWED_ATTR: [],
};

export function sanitizeHTML(dirty) {
  if (dirty == null || dirty === "") return "";
  return DOMPurify.sanitize(String(dirty), PROP_IA_CHAT_FRAGMENT);
}
